import { defaultDropdownValue } from '../../components/Dropdown'

export const refreshOptions = [
  defaultDropdownValue,
  { label: '30 sec', value: 30000 },
  { label: '1 min', value: 60000 },
  { label: '2 min', value: 120000 },
  { label: '5 min', value: 300000 }
]
